"use client"

import { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { motion, AnimatePresence } from "framer-motion"
import Slider from "react-slick";
import { User, CreditCard, ChevronRight, X } from "lucide-react"
import "../styles/compra.css"
import atencao from "../assets/atencao.webp"
import axios from "axios"
const CompraPasso1 = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { evento } = location.state || {}

  const [categorias, setCategorias] = useState([])
  const [categoriaSelecionada, setCategoriaSelecionada] = useState("")
  const [cpf, setCpf] = useState("")
  const [nome, setNome] = useState("")
  const [apelido, setApelido] = useState("") // 🔹 NOVO: apelido do vaqueiro
  const [aviso, setAviso] = useState(null)
  const [mostrarModal, setMostrarModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [categoriasEsgotadas, setCategoriasEsgotadas] = useState({})
  const [sponsors, setSponsors] = useState([]);

  // 💡 NOVO: Estados de validação de Filiação do Circuito
  const [categoriasPermitidas, setCategoriasPermitidas] = useState([]);
  const [verificouFiliacao, setVerificouFiliacao] = useState(false);

  const [sugestoes, setSugestoes] = useState([]);
  const [dadosSelecionados, setDadosSelecionados] = useState(null); // Guarda o objeto completo

  useEffect(() => {
    const buscarAviso = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/avisos/${evento._id}/comprador`)
        const data = await res.json()
        if (data?.mensagem) {
          setAviso(data.mensagem)
          setMostrarModal(true)
        }
      } catch (err) {
        console.error("Erro ao buscar aviso:", err)
      }
    }
    if (evento?._id) buscarAviso()
  }, [evento])
  useEffect(() => {
    const cpfLimpo = cpf.replace(/\D/g, '');
    if (cpfLimpo.length === 11) {
      axios.get(`https://api.ticketdovaqueiro.com/api/pedidos/sugestoes-por-cpf/${cpfLimpo}`)
        .then(res => setSugestoes(res.data))
        .catch(err => console.error("Erro ao buscar sugestões", err));
    } else {
      setSugestoes([]);
    }
  }, [cpf]);  
  useEffect(() => {
    const fetchSponsors = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/sponsors`);
        const data = await res.json();
        setSponsors(data);
      } catch (err) {
        console.error("Erro ao carregar patrocinadores:", err);
      }
    };
    fetchSponsors();
  }, []);

  useEffect(() => {
    const usuarioLogado = localStorage.getItem("token")
    if (!usuarioLogado) {
      alert("⚠️ Você precisa estar logado para continuar a compra.")
      navigate("/login", { state: { from: location.pathname } })
      return
    }
  }, [navigate, location.pathname])

  useEffect(() => {
    // Verifica o limite de cada categoria usando o novo endpoint /pedidos/limite
    // Esse endpoint já leva em conta limites compartilhados entre categorias.
    const verificarCategoriasEsgotadas = async () => {
      const esgotadas = {}
      for (const cat of evento.categorias) {
        const temLimite = (cat?.limiteSenhasVendidas || 0) > 0 || !!cat?.limiteCompartilhadoCom
        if (!temLimite) continue
        try {
          const res = await fetch(
            `${process.env.REACT_APP_API_URL}/pedidos/limite/${evento._id}/${encodeURIComponent(cat.nome)}`
          )
          const data = await res.json()
          if (data.esgotada) {
            esgotadas[cat.nome] = data
          }
        } catch (err) {
          console.error(`Erro ao verificar limite da categoria ${cat.nome}:`, err)
        }
      }
      setCategoriasEsgotadas(esgotadas)
    }

    if (evento?.categorias) {
      setCategorias(evento.categorias)
      setCategoriaSelecionada(evento.categorias[0]?.nome || "")
      verificarCategoriasEsgotadas()
    }
  }, [evento])

  useEffect(() => {
    const audio = new Audio("/audios/passo1.mp3")
    audio.play().catch(e => console.error("Erro ao reproduzir áudio:", e))
    return () => { audio.pause(); audio.currentTime = 0 }
  }, [])

  // Validação de CPF
  const validarCPF = (cpf) => {
    cpf = cpf.replace(/[^\d]+/g, "")
    if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false
    let soma = 0
    for (let i = 0; i < 9; i++) soma += Number.parseInt(cpf.charAt(i)) * (10 - i)
    let resto = (soma * 10) % 11
    if (resto === 10 || resto === 11) resto = 0
    if (resto !== Number.parseInt(cpf.charAt(9))) return false
    let soma2 = 0
    for (let i = 0; i < 10; i++) soma2 += Number.parseInt(cpf.charAt(i)) * (11 - i)
    let resto2 = (soma2 * 10) % 11
    if (resto2 === 10 || resto2 === 11) resto2 = 0
    return resto2 === Number.parseInt(cpf.charAt(10))
  }

  // 💡 MÁGICA: Gatilho que dispara a busca no Backend quando o CPF atinge 11 dígitos
  useEffect(() => {
    const cpfNumerico = cpf.replace(/\D/g, "");
    
    // 💡 CORREÇÃO: Pega o ID de forma segura, seja ele uma string simples ou um objeto populado.
    const idDoCircuito = evento?.circuitoId?._id || evento?.circuitoId;

    if (cpfNumerico.length === 11 && idDoCircuito) {
      console.log(`🔍 Verificando CPF ${cpfNumerico} no Circuito ${idDoCircuito}...`); // Log para depuração
      
      fetch(`${process.env.REACT_APP_API_URL}/circuitos/${idDoCircuito}/verificar-cpf/${cpfNumerico}`)
        .then(res => res.json())
        .then(data => {
          console.log("✅ Resposta da Filiação:", data);
          setVerificouFiliacao(true);
          
          if (data.filiado) {
             setNome(data.nomeVaqueiro); // Autopreencher o nome!
             setCategoriasPermitidas(data.categoriasPagas); // Categorias que ele pagou
          } else {
             setCategoriasPermitidas([]);
          }
        })
        .catch(err => {
          console.error("❌ Erro verificar CPF:", err);
          setVerificouFiliacao(true); // Evita travar a tela pra sempre em caso de queda de internet
        });
    } else if (cpfNumerico.length < 11) {
      setVerificouFiliacao(false);
      setCategoriasPermitidas([]);
    }
  }, [cpf, evento]);

  const handleCpfChange = (e) => {
    let value = e.target.value.replace(/\D/g, "").slice(0, 11)
    if (value.length > 9) {
      value = value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")
    } else if (value.length > 6) {
      value = value.replace(/(\d{3})(\d{3})(\d{1,3})/, "$1.$2.$3")
    } else if (value.length > 3) {
      value = value.replace(/(\d{3})(\d{1,3})/, "$1.$2")
    }
    setCpf(value)
  }

  const continuar = async () => {
    setLoading(true)
    const cpfNumerico = cpf.replace(/[^\d]+/g, "")

    if (!cpf || !nome || !categoriaSelecionada) {
      alert("⚠️ Por favor, preencha todos os campos.")
      setLoading(false)
      return
    }

    if (!validarCPF(cpfNumerico)) {
      alert("⚠️ CPF inválido. Verifique e tente novamente.")
      setLoading(false)
      return
    }

    // 🔒 TRAVA DE SEGURANÇA: Se ele conseguiu burlar o <select>, barramos aqui.
    const catObj = categorias.find(c => c.nome === categoriaSelecionada);
    if (catObj?.requerFiliacao && !categoriasPermitidas.includes(categoriaSelecionada)) {
        setAviso(`❌ A categoria "${categoriaSelecionada}" é exclusiva para vaqueiros com Associação Ativa no Campeonato. Vá na página do circuito e associe-se antes de comprar a senha!`);
        setMostrarModal(true);
        setLoading(false);
        return;
    }

    // Verifica limite via endpoint unificado (respeita limites compartilhados)
    const temLimite = (catObj?.limiteSenhasVendidas || 0) > 0 || !!catObj?.limiteCompartilhadoCom
    if (temLimite) {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/pedidos/limite/${evento._id}/${encodeURIComponent(categoriaSelecionada)}`
        )
        const data = await res.json()
        if (data.esgotada) {
          const msg = data.categoriasNoPool?.length > 1
            ? `❌ Limite de ${data.limite} senhas atingido (pool compartilhado entre ${data.categoriasNoPool.join(" + ")}). Não há mais vagas disponíveis.`
            : `❌ Limite de ${data.limite} senhas já atingido para a categoria "${categoriaSelecionada}".`
          setAviso(msg)
          setMostrarModal(true)
          setLoading(false)
          return
        }
      } catch (err) {
        alert("Erro ao verificar limite de senhas. Tente novamente.")
        setLoading(false)
        return
      }
    }

    navigate("/compra-passo-2", {
      state: {
          cpf,
          nome,
          apelido,          // 🔹 NOVO: segue pela corrente até o Passo3 criar o pedido
          categoriaSelecionada,
          evento,
          dadosPreenchidos: dadosSelecionados,
        },
      });
    setLoading(false)
  }

  if (!evento) {
    return (
      <div className="compra-loading">
        <div className="loading-spinner"></div>
        <p>Carregando evento...</p>
      </div>
    )
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="compra-container fluxo-compra-simples passo1-simples"
    >
      <header className="flow-simple-header">
        <span className="flow-step-badge">1 de 3</span>
        <div>
          <h1>Quem vai correr?</h1>
          <p>Digite os dados do vaqueiro.</p>
        </div>
      </header>

      <div className="compra-form2">
        <div className="form-group">
          <label htmlFor="cpf">
            <CreditCard size={18} className="input-icon55" />
            CPF
          </label>
          <input
            type="text"
            id="cpf"
            value={cpf}
            onChange={handleCpfChange}
            placeholder="Digite o CPF"
            maxLength={14}
          />
        </div>

        <div className="form-group">
            <label>Nome do vaqueiro</label>
            <div className="input-with-icon">
              <User className="input-icon" />
              <input
                type="text"
                value={nome}
                onChange={(e) => setNome(e.target.value)}
                placeholder="Digite o nome completo"
                required
              />
            </div>

            {/* ⚡ LISTA DE SUGESTÕES INTELIGENTE */}
            <AnimatePresence>
              {sugestoes.length > 0 && (
                <motion.div
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.3 }}
                  className="sugestoes-container"
                >
                  <small>Encontramos estes dados</small>
                  {sugestoes.map((s, i) => (
                    <div 
                      key={i} 
                      className="sugestao-item" 
                      onClick={() => {
                        setNome(s.nomeVaqueiro);
                        setApelido(s.apelido || ""); // 🔹 preenche apelido do histórico
                        setDadosSelecionados(s);
                        setSugestoes([]);
                      }}
                    >
                      <div className="sugestao-info">
                        <span className="sugestao-nome">{s.nomeVaqueiro}</span>
                        {s.representacao && (
                          <span className="sugestao-rep">{s.representacao}</span>
                        )}
                      </div>
                      <ChevronRight size={18} className="sugestao-icon" />
                    </div>
                  ))}
                </motion.div>
              )}
            </AnimatePresence>
          </div>

        {/* 🔹 NOVO: Apelido do vaqueiro */}
        <div className="form-group">
          <label htmlFor="apelido">
            Apelido <span style={{ color: '#888', fontWeight: 'normal', fontSize: '12px' }}>(como é chamado na pista — opcional)</span>
          </label>
          <div className="input-with-icon">
            <User className="input-icon" />
            <input
              type="text"
              id="apelido"
              value={apelido}
              onChange={(e) => setApelido(e.target.value)}
              placeholder="Ex: Zézinho, Gaúcho, Baiano..."
            />
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="categoria">Categoria</label>
          <select
            id="categoria"
            value={categoriaSelecionada}
            onChange={(e) => setCategoriaSelecionada(e.target.value)}
          >
            {categorias.map((cat, index) => {
              let bloqueada = false;
              let txtExtra = "";

              // Verifica regras de bloqueio
              if (categoriasEsgotadas[cat.nome]) {
                bloqueada = true;
                txtExtra = " — ESGOTADA";
              } else if (cat.requerFiliacao) { // 💡 Se a categoria exige filiação...
                if (!verificouFiliacao) {
                  bloqueada = true;
                  txtExtra = " — DIGITE O CPF";
                } else if (!categoriasPermitidas.includes(cat.nome)) {
                  bloqueada = true;
                  txtExtra = " — BLOQUEADA";
                } else {
                  txtExtra = " — LIBERADA";
                }
              }

              return (
                <option key={index} value={cat.nome} disabled={bloqueada}>
                  {cat.nome} {txtExtra}
                </option>
              )
            })}
          </select>
        </div>

        <motion.button
          onClick={continuar}
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.97 }}
          disabled={loading}
          className="btn-continuar"
        >
          {loading ? (
            <div className="button-loader"></div>
          ) : (
            <>
              ESCOLHER SENHA
              <ChevronRight size={20} />
            </>
          )}
        </motion.button>
      </div>

      {/* Patrocinadores */}
      {sponsors.length > 0 && (
        <div className="sponsors-section">
          <h3>Apoio</h3>
          <Slider
            dots={false}
            infinite
            autoplay
            autoplaySpeed={2500}
            arrows={false}
            pauseOnHover={false}
            slidesToShow={4}
            slidesToScroll={1}
            responsive={[
              { breakpoint: 1200, settings: { slidesToShow: 3 } },
              { breakpoint: 768, settings: { slidesToShow: 2 } },
              { breakpoint: 480, settings: { slidesToShow: 1 } },
            ]}
          >
            {sponsors.map((s) => (
              <a key={s._id} href={s.link} target="_blank" rel="noopener noreferrer">
                <img src={s.imagem} alt="Patrocinador" className="sponsor-img" />
              </a>
            ))}
          </Slider>
        </div>
      )}

      {/* Modal do Aviso */}
      <AnimatePresence>
        {mostrarModal && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="aviso-modal"
            onClick={() => setMostrarModal(false)}
          >
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ type: "spring", damping: 20 }}
              className="aviso-conteudo"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="aviso-header">
                <img src={atencao || "/placeholder.svg"} alt="Atenção" className="aviso-conteudo-img" />
                <h1>Atenção</h1>
              </div>
              <div className="aviso-body">
                <p>{aviso}</p>
              </div>
              <div className="aviso-footer">
                <motion.button onClick={() => setMostrarModal(false)} whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }} className="btn-entendi">
                  Entendi
                </motion.button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  )
}

export default CompraPasso1